var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-container techsearch" }, [
    _c("h1", { staticClass: "title_offers" }, [_vm._v("Digitale Angebote")]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-container" }, [
      _c("div", { staticClass: "search-container" }, [
        _c("div", { staticClass: "searchbar" }, [
          _c("div", { staticClass: "searchbar__bar" }, [
            _c("div", { staticClass: "searchbar__bar__decoration" }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "searchbarWrapper d-flex align-center justify-center"
              },
              [
                _c(
                  "div",
                  { staticClass: "searchbar__input" },
                  [
                    _c("v-text-field", {
                      staticClass: "searchBar",
                      attrs: {
                        "hide-details": "",
                        "append-icon": "mdi-magnify",
                        solo: "",
                        height: "80px",
                        flat: "",
                        placeholder: "Suchen Sie nach Digitalen Angeboten"
                      },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.goToResult()
                        }
                      },
                      model: {
                        value: _vm.searchterm,
                        callback: function($$v) {
                          _vm.searchterm = $$v
                        },
                        expression: "searchterm"
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "searchbarCategoryWrapper" })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "searchbarCategories text-center" },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.categories,
                  label: "Angebot-Kategorie",
                  outlined: ""
                },
                on: {
                  change: function($event) {
                    return _vm.getDigitalOffersByCategory()
                  }
                },
                model: {
                  value: _vm.input.catKey,
                  callback: function($$v) {
                    _vm.$set(_vm.input, "catKey", $$v)
                  },
                  expression: "input.catKey"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "left-sidebar" },
        [
          _c(
            "v-card",
            { staticClass: "searchCard pa-4", attrs: { raised: "" } },
            [
              _vm.firstLoad
                ? _c("v-skeleton-loader", {
                    staticClass: "pa-5",
                    attrs: {
                      loading: _vm.loading,
                      type:
                        "card-heading, paragraph, text@3, paragraph, text@3",
                      "min-height": "70vh"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.firstLoad,
                      expression: "!firstLoad"
                    }
                  ]
                },
                [
                  _c("v-card-title", { staticClass: "black--text" }, [
                    _c("h5", [_vm._v(_vm._s(_vm.categoryName))])
                  ]),
                  _vm._v(" "),
                  _c("v-card-text", { staticClass: "text--primary" }, [
                    _vm._v(_vm._s(_vm.categoryDescription))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-results" },
        [
          _c(
            "v-card",
            { staticClass: "searchCard", attrs: { raised: "" } },
            [
              _vm.firstLoad
                ? _c("v-skeleton-loader", {
                    staticClass: "pa-5",
                    attrs: {
                      loading: _vm.loading,
                      type: "card-heading, list-item-avatar-two-line@6"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.firstLoad,
                      expression: "!firstLoad"
                    }
                  ]
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "searchCard__title black--text px-6 pt-8" },
                    [
                      _c("h5", [_vm._v("Digitale Angebote")]),
                      _vm._v(" "),
                      _vm.searchresults.length !== 1
                        ? _c("h5", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.searchresults.length) +
                                " Ergebnisse\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.searchresults.length == 1
                        ? _c("h5", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.searchresults.length) +
                                " Ergebnis\n            "
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.searchresults.length == 0
                    ? _c("v-card-text", [
                        _c(
                          "div",
                          { staticClass: "text-center mt-12" },
                          [
                            _c("v-icon", { staticClass: "mr-2" }, [
                              _vm._v("error")
                            ]),
                            _vm._v(" Keine Suchergebnisse\n            ")
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "scrolling-area" },
                    [
                      _c(
                        "v-list",
                        [
                          _c(
                            "transition-group",
                            { attrs: { name: "fade" } },
                            _vm._l(_vm.searchresults, function(item) {
                              return _c(
                                "v-card",
                                {
                                  key: item.hash,
                                  staticClass: "techresultCard",
                                  attrs: { outlined: "" }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "no-link",
                                      attrs: {
                                        to: {
                                          name: "OfferDetail",
                                          params: { hash: item.hash }
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-item",
                                        { attrs: { "three-line": "" } },
                                        [
                                          _c(
                                            "v-list-item-avatar",
                                            {
                                              staticClass: "searchResultIcon",
                                              attrs: {
                                                size: "80px",
                                                rounded: ""
                                              }
                                            },
                                            [
                                              item.image != "undefined"
                                                ? _c("img", {
                                                    attrs: {
                                                      "item.image": "",
                                                      src:
                                                        "/static/uploads/" +
                                                        item.image
                                                    },
                                                    on: { error: _vm.setAltImg }
                                                  })
                                                : _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        width: "80",
                                                        height: "80",
                                                        viewBox: "0 0 80 80",
                                                        fill: "none",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg"
                                                      }
                                                    },
                                                    [
                                                      _c("rect", {
                                                        attrs: {
                                                          width: "80",
                                                          height: "80",
                                                          rx: "6",
                                                          fill: "#BFBFBF"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          d:
                                                            "M40 26.6667L53.3333 35.3333V44.6667L40 53.3333L26.6666 44.6667V35.3333L40 26.6667Z",
                                                          stroke: "black",
                                                          "stroke-width": "2",
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          d:
                                                            "M40 53.3333V44.6667",
                                                          stroke: "black",
                                                          "stroke-width": "2",
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          d:
                                                            "M53.3333 35.3333L40 44.6667L26.6666 35.3333",
                                                          stroke: "black",
                                                          "stroke-width": "2",
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          d:
                                                            "M26.6666 44.6667L40 35.3333L53.3333 44.6667",
                                                          stroke: "black",
                                                          "stroke-width": "2",
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          d:
                                                            "M40 26.6667V35.3333",
                                                          stroke: "black",
                                                          "stroke-width": "2",
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round"
                                                        }
                                                      })
                                                    ]
                                                  )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  _vm._s(item.name) +
                                                    "\n                        "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("v-list-item-subtitle", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    item.description
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-457218da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-457218da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/offersearch/views/OfferSearchMain.vue
// module id = null
// module chunks = 